import React, { useState, useContext, useRef } from "react"
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment'
import 'moment/locale/fr'
import { Box } from '@mui/material';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MailOutlineIcon from '@mui/icons-material/MailOutline';

import ViewResultsModal from "../ui/ViewResultsModal"
import CandidatRow, { infosStatut } from "./CandidatRow"

import PopupNotifContext from "../../contexts/PopupNotifContext"

import APIS from "../../utils/APIS"
import { estLimiteInvitations, messageLimiteInvitations } from "../../utils/limiteInvitations"

moment.locale("fr");

// Point 20 : la ligne candidat vient du composant partage CandidatRow,
// le meme que la page « Candidats ». Ici on y ajoute la logique metier de la
// page d'une offre : ouvrir le radar d'un scan termine, reinviter un candidat
// qui n'a pas commence.

const RecruiterUserRows = ({ userList, actScan }) => {

  const [modalViewResults, setModalViewResults] = useState(false)

  const { addPopupNotif } = useContext(PopupNotifContext)

  /* B38 (25/09/2026) : un double clic sur l'enveloppe envoyait deux relances,
     donc deux emails au candidat. Une relance en cours bloque la suivante pour
     la meme adresse, jusqu'a la reponse du serveur. */
  const relancesEnCours = useRef(new Set())

  const reInvit = (user) => {
    const adresse = user?.userEmail
    if (relancesEnCours.current.has(adresse)) return
    relancesEnCours.current.add(adresse)
    let closeDate = moment(actScan?.plan?.plan[0]?.closeDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
    APIS.reInvitCandidat({email : user?.userEmail, groupeID : actScan?.id, closeDate : closeDate}).then((result) => {
      relancesEnCours.current.delete(adresse)
      if (result?.message === "reInvitCandidat") {
        addPopupNotif({
          uuid : uuidv4(),
          text : user?.userEmail+" a bien été réinvité\u00a0!",
          type : "confirmation",
          removeAfter:5000,
        })
      } else if (estLimiteInvitations(result)) {
        addPopupNotif({
          uuid : uuidv4(),
          text : messageLimiteInvitations(result),
          type : "error",
          removeAfter:8000,
        })
      } else {
        addPopupNotif({
          uuid : uuidv4(),
          text : "Erreur\u00a0!",
          type : "error",
          removeAfter:5000,
        })
      }
    })
  }

  return (
    <>
      <Box sx={{display:"flex", flexDirection:"column", gap:["7px", "10px", "13px"]}}>
        {userList?.map((user, index) => {
          let resultForThisUser = actScan?.userResults?.find((el) => el?.userID === user?.userID)
          const { progress, statut, result } = infosStatut(resultForThisUser)

          let action = null
          if (statut === "ended") {
            action = <ChevronRightIcon sx={{height:"40px", width:"40px"}}/>
          } else if (statut === "notStarted") {
            action = (
              <MailOutlineIcon
                onClick={(e) => {
                  e.stopPropagation()
                  reInvit(user)
                }}
                sx={{height:"30px", width:"30px", cursor:"pointer"}}
              />
            )
          }

          return (
            <CandidatRow
              key={index}
              nom={user?.userName}
              email={user?.userEmail}
              compteActive={user?.actived === "true"}
              progression={progress}
              statut={statut}
              resultat={result}
              clickable={statut === "ended"}
              onClick={() => {
                if (statut === "ended") {
                  setModalViewResults(user)
                }
              }}
              action={action}
            />
          )
        })}
      </Box>

      <ViewResultsModal
        isOpen={modalViewResults === false ? false : true}
        actScan={actScan}
        user={modalViewResults}
        onClose={() => setModalViewResults(false) }
        type="recruiter"
      />
    </>
  )
};

export default RecruiterUserRows;
